var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var DropZoneWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  margin-top: ", ";\n  .logo-drop-zone{\n    height: 120px;\n    border-width: 1px;\n    border-color: #666;\n    border-style: dashed;\n  }\n"], ["\n  display: block;\n  margin-top: ", ";\n  .logo-drop-zone{\n    height: 120px;\n    border-width: 1px;\n    border-color: #666;\n    border-style: dashed;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.four;
});
export default DropZoneWrapper;
var templateObject_1;
